export enum TipoConteudo {
  ConteudoTexto = 'Conteúdo de Texto',
}
